import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>AppsDNA</h1>
        <p>Mobile Application Development</p>
        <a href="mailto:team@appdna.ai" className="cta-button">Contact Us</a>
      </div>
    </section>
  );
}

export default Hero;